import { IRenter, SignatureInfo } from "../../../../../../../../types/renter.type";
import { formatDate } from "../../../../../../../../common/helpers/date.helpers";
import { useState } from "react";
import { Period } from "../../../../../../../../common/services/plans.api";
import { getPlanDays, getPlanLabel, getPlanMonths } from "../AdditionsPlan";

export function useReactivatePlan(renter: IRenter) {
  const [signatureInfo, setSignatureInfo] = useState<SignatureInfo>()

  function handleSignature(contractInfo) {
    setSignatureInfo(contractInfo)
  }

  const renterId = renter._id!;
  const odlPlanData = renter.desactivationData?.planHistory;
  const renterName = renter.name;

  let oldPlanType;
  let oldPlanName;
  let unlinkDate;
  let initialDateSubscription;
  let licensePlate;
  if (odlPlanData && odlPlanData.length > 0) {
    oldPlanType = odlPlanData[odlPlanData.length - 1].planType;
    oldPlanName = odlPlanData[odlPlanData.length - 1].label;         
    initialDateSubscription = odlPlanData[odlPlanData.length - 1].planHistoryInitial
  } else {
    oldPlanType = renter.activationData?.plan.planType;
    oldPlanName = renter.activationData?.plan.label;
    initialDateSubscription = renter.activationData?.plan.subscriptionInitialDate;
  }

  const vehicleHistory = renter.desactivationData?.vehicleHistory;
  let vehicle;


  if (vehicleHistory && vehicleHistory.length > 0) {
    vehicle = vehicleHistory[vehicleHistory.length - 1].id;
    unlinkDate = vehicleHistory[vehicleHistory.length - 1].vehicleHistoryEnd
    licensePlate = vehicleHistory[vehicleHistory.length - 1].licensePlate;
  }

  // Defina os registros iniciais como você deseja
  const initialRegisters = [
    { type: 'Frente do veículo', content: '' },
    { type: 'Lateral direita do veículo', content: '' },
    { type: 'Lateral esquerda do veículo', content: '' },
    { type: 'Traseira do veículo', content: '' },
    { type: 'Odômetro', content: '' },
  ];

  const period: Period = {
    value: oldPlanType,
    label: getPlanLabel(oldPlanType),
    months: getPlanMonths(oldPlanType),
    days: getPlanDays(oldPlanType),
  };


  const contractData = {
    renterId: renterId,
    vehicleId: vehicle,
    period: period,
  }
  

  return {
    oldPlanType,
    oldPlanName,
    unlinkDate: unlinkDate ? formatDate(unlinkDate) : undefined,
    initialRegisters,
    vehicle,
    renterId,
    contractData,
    handleSignature,
    signatureInfo,
    initialDateSubscription,
    renterName,
    licensePlate
  };
}
